<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="popupTitle"
      :active.sync="isPopupActiveLocal"
    >
      <vs-card class="couponCard">
        <div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                label="Coupon Name"
                v-model="couponName"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                label="Coupon Code"
                v-model="couponCode"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-1/2">
              <label>Coupon Type</label>
              <v-select
                v-model="couponType"
                :clearable="false"
                :options="chooseCouponType"
                name="name"
                @input="emptyOldData"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
            <div class="vx-col w-1/2">
              <!-- <label>Aplicable To</label>
              <v-select
                v-model="applicableTo"
                :clearable="false"
                :options="existingArray"
                name="name"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              /> -->
              <vs-select
                placeholder="Choose/Type"
                multiple
                autocomplete
                class="selectExample w-full"
                name="item-text"
                label="Aplicable to"
                v-model="aplicableTo"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.label"
                  v-for="(item, index) in existingArray"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-1/2">
              <label>Usage Type</label>
              <v-select
                v-model="usageType"
                :clearable="false"
                :options="chooseUsageType"
                name="name"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
            <div class="vx-col w-1/2">
              <vs-input
                class="w-full"
                label="limit"
                type="number"
                :disabled="disAbleLimit"
                v-model="limit"
              />
              <!-- <v-select
                v-model="limit"
                :clearable="false"
                :options="existingArray"
                name="name"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              /> -->
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-1/2">
              <div class="vx-row mb-6">
                <div class="vx-col w-2/5">
                  <label>Type</label>
                  <v-select
                    v-model="discountType"
                    :clearable="false"
                    :options="chooseDiscountType"
                    name="name"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  />
                </div>
                <div class="vx-col w-3/5">
                  <!-- <label>Amount/Value</label> -->
                  <vs-input
                    class="w-full"
                    label="Amount/Value"
                    type="number"
                    v-model="discount"
                  />
                  <!-- <v-select
                    v-model="discount"
                    :clearable="false"
                    :options="existingArray"
                    name="name"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  /> -->
                </div>
              </div>
            </div>

            <div class="vx-col w-1/2" v-if="toggleMaxUpto">
              <vs-input
                class="w-full"
                label="Max Upto"
                type="number"
                v-model="maxDiscountAmount"
              />
            </div>
          </div>

          <!-- <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                type="number"
                label="Amount"
                v-model="couponAmount"
              />
            </div>
          </div> -->

          <!-- <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                type="number"
                label="Percentage"
                v-model="couponPercentage"
              />
            </div>
          </div> -->

          <!-- <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                type="number"
                label="Valid Days"
                v-model="couponValidDays"
              />
            </div>
          </div> -->

          <div class="vx-row mb-6">
            <div class="vx-col w-1/2">
              <label class="text-sm">Valid from</label>
              <flat-pickr
                v-model="validFrom"
                :config="{ dateFormat: 'd F Y' }"
                class="w-full"
              />
            </div>

            <div class="vx-col w-1/2">
              <label class="text-sm">Valid till</label>
              <flat-pickr
                v-model="validTill"
                :config="{ dateFormat: 'd F Y' }"
                class="w-full"
              />
            </div>
          </div>
          <div class="vx-col w-1/2">
            <vs-checkbox v-model="isEnabled" class="mb-3"
              >Enable Coupon</vs-checkbox
            >
          </div>

          <div class="vx-row mb-6"></div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button class="mr-3 mb-2" @click="submit">Submit</vs-button>
            </div>
          </div>
        </div>
      </vs-card>
    </vs-popup>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  props: {
    isPopupActive: {
      type: Boolean,
      required: true
    },
    couponData: {
      type: Object,
      default: () => {}
    },
    productInfo: {
      type: Array,
      default: () => []
    },
    userInfo: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    flatPickr
  },
  data() {
    return {
      popupTitle: 'Add Coupon',
      couponId: null,
      couponName: null,
      couponCode: null,

      aplicableTo: [],
      existingArray: [],
      couponType: null,
      chooseCouponType: [
        { label: 'GENERIC', value: 'GENERIC' },
        { label: 'USER', value: 'USER' },
        { label: 'PRODUCT', value: 'PRODUCT' }
      ],
      usageType: null,
      chooseUsageType: [
        { label: 'SINGLE_USE', value: 'SINGLE_USE' },
        { label: 'MULTI_USE', value: 'MULTI_USE' },
        { label: 'UNLIMTED_USE', value: 'UNLIMTED_USE' }
      ],
      discountType: null,
      chooseDiscountType: [
        { label: '%', value: 'PERCENTAGE' },
        { label: '₹', value: 'AMOUNT' }
      ],
      toggleMaxUpto: false,
      maxDiscountAmount: null,
      discount: null,
      limit: null,
      disAbleLimit: false,
      validFrom: null,
      validTill: null,
      isEnabled: false
    }
  },
  methods: {
    initValues() {
      this.popupTitle = ''
      this.couponId = null
      this.couponName = null
      this.couponCode = null
      this.aplicableTo = null
      this.existingArray = []
      this.couponType = null
      this.chooseCouponType = [
        { label: 'GENERIC', value: 'GENERIC' },
        { label: 'USER', value: 'USER' },
        { label: 'PRODUCT', value: 'PRODUCT' }
      ]
      this.usageType = null
      this.chooseUsageType = [
        { label: 'SINGLE_USE', value: 'SINGLE_USE' },
        { label: 'MULTI_USE', value: 'MULTI_USE' },
        { label: 'UNLIMTED_USE', value: 'UNLIMTED_USE' }
      ]
      this.discountType = null
      this.chooseDiscountType = [
        { label: '%', value: 'PERCENTAGE' },
        { label: '₹', value: 'AMOUNT' }
      ]
      this.toggleMaxUpto = false
      this.maxDiscountAmount = null
      this.discount = null
      this.limit = null
      this.disAbleLimit = false
      this.validFrom = null
      this.validTill = null
      this.isEnabled = false
    },
    submit() {
      const coupon = {
        name: this.couponName,
        couponCode: this.couponCode,
        couponType: this.couponType ? this.couponType.value : null,
        aplicableTo: this.aplicableTo,
        usageType: this.usageType ? this.usageType.value : null,
        limit: this.limit,
        discountType: this.discountType ? this.discountType.value : null,
        validFrom: this.validFrom,
        validTill: this.validTill,
        isEnabled: this.isEnabled
      }

      if (this.discountType) {
        if (this.discountType.value === 'PERCENTAGE') {
          coupon.percentageDiscount = this.discount
          coupon.maxDiscountAmount = this.maxDiscountAmount
        } else if (this.discountType.value === 'AMOUNT') {
          coupon.amountDiscount = this.discount
        }
      }

      console.log('add coupon data', coupon)
      if (this.couponId !== null) {
        //update coupon
        coupon.id = this.couponId
        this.$store
          .dispatch('coupons/updateCoupon', coupon)
          .then((response) => {
            this.successMsg(response.data.data)
          })
          .catch((err) => {
            console.error(err)
            this.errorMsg(err)
          })
      } else {
        //add coupon
        this.$store
          .dispatch('coupons/addCoupon', coupon)
          .then((response) => {
            this.successMsg(`${response.data.data[0].name} added`)
          })
          .catch((err) => {
            console.error(err)
            this.errorMsg(err)
          })
      }
      this.$emit('closePopup')
      this.initValues()
    },
    successMsg(message) {
      this.$vs.notify({
        title: 'Success',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    errorMsg(errMsg) {
      this.$vs.notify({
        title: 'Failed',
        text: errMsg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    },
    emptyOldData() {
      console.log('inside emptyOldData')
      this.aplicableTo = []
    }
  },
  computed: {
    isPopupActiveLocal: {
      get() {
        return this.isPopupActive
      },
      set(val) {
        if (!val) {
          this.$emit('closePopup')
          // this.$validator.reset()
          // this.couponData = {}
          this.initValues()
        }
      }
    }
  },
  watch: {
    isPopupActive(val) {
      console.log('data val', Object.entries(this.couponData).length, val)
      if (!val) return
      if (val) {
        if (Object.entries(this.couponData).length !== 0) {
          this.popupTitle = 'Edit Coupon'
          const {
            _id,
            name,
            couponCode,
            couponType,
            usageType,
            discountType,
            aplicableTo,
            limit,
            percentageDiscount,
            maxDiscountAmount,
            amountDiscount,
            validFrom,
            validTill,
            isEnabled
          } = JSON.parse(JSON.stringify(this.couponData))
          console.log('watch data', this.couponData)
          this.couponId = _id
          this.couponName = name
          this.couponCode = couponCode
          this.aplicableTo = aplicableTo
          this.limit = limit

          this.maxDiscountAmount = maxDiscountAmount
          this.validFrom = validFrom
          this.validTill = validTill
          this.isEnabled = isEnabled
          if (couponType) {
            this.chooseCouponType.forEach((type) => {
              if (type.value === couponType) {
                this.couponType = type
              }
            })
            // if (couponType === 'PRODUCT') {
            //   const dbData = []
            //   this.productInfo.forEach((prod) => {
            //     // console.log('prod && aplicableTo', prod, aplicableTo)
            //     if (aplicableTo.includes(prod.values)) {
            //       console.log('i caem inside')
            //       dbData.push(prod)
            //     }
            //   })
            //   console.log('dbData', dbData)
            //   this.aplicableTo = dbData
            // }
          }
          if (usageType) {
            this.chooseUsageType.forEach((type) => {
              if (type.value === usageType) {
                this.usageType = type
              }
            })
          }
          if (discountType) {
            this.chooseDiscountType.forEach((type) => {
              if (type.value === discountType) {
                this.discountType = type
              }
            })
            if (discountType === 'PERCENTAGE') {
              this.discount = percentageDiscount
            } else if (discountType === 'AMOUNT') {
              this.discount = amountDiscount
            }
          }
        } else {
          this.popupTitle = 'Add Coupon'
        }
      }
    },
    couponType(val) {
      console.log('iam here', val)
      if (!val) return
      if (val.value === 'GENERIC') {
        this.aplicableTo = ['ALL']
        this.existingArray = [{ label: 'ALL', value: 'ALL' }]
      } else if (val.value === 'USER') {
        // this.aplicableTo = []
        console.log('userInfo', this.userInfo)
        if (this.userInfo && this.userInfo.length) {
          this.existingArray = [...this.userInfo]
          // this.userInfo.forEach((user) => {
          //   this.existingArray.push({ label: user.name, value: user._id })
          // })
        }
        // this.existingArray = [
        //   { label: 'user1', value: 'user._id1' },
        //   { label: 'user2', value: 'user._id2' },
        //   { label: 'user3', value: 'user._id3' }
        // ]
      } else if (val.value === 'PRODUCT') {
        // this.aplicableTo = []
        if (this.productInfo && this.productInfo.length) {
          this.existingArray = [...this.productInfo]
          // this.productInfo.forEach((product) => {
          //   this.existingArray.push({ label: product.name, value: product._id })
          // })
        }
      }
    },
    discountType(val) {
      console.log('choosen disc type val', val)
      if (!val) return
      if (val.value === 'PERCENTAGE') {
        this.toggleMaxUpto = true
      } else {
        this.toggleMaxUpto = false
      }
    },
    usageType(val) {
      if (!val) return
      if (val.value === 'SINGLE_USE') {
        this.limit = 1
        this.disAbleLimit = true
      } else if (val.value === 'MULTI_USE') {
        this.disAbleLimit = false
        this.limit = 1
      } else if (val.value === 'UNLIMTED_USE') {
        this.disAbleLimit = true
        this.limit = 0
      }
    }
  }
}
</script>

<style scoped>
.couponCard {
  width: 100;
}
</style>
